import { canonicalPathToFlattenPath } from '@procuros/datachecks';

export const normalizeAnnotationPath = (
  path: string,
  canonical: Record<string, unknown> | undefined | null,
): string | undefined => {
  if (!path) {
    return path;
  }
  const stripped = path.startsWith('$') ? path.slice(1).replace(/^\./, '') : path;
  if (!stripped) {
    return stripped;
  }
  return canonicalPathToFlattenPath(stripped, canonical);
};
